<template>
    <div>
			<el-form :model="openDay" :rules="rules" ref="updateOpenDayForm"
							 label-width="110px" size="small" label-position="left" style="padding:20px 10px;min-height: 150px;"
			label-suffix="：" :status-icon="true">
				<el-form-item label="开放日期" prop="openTime" >
					<el-date-picker value-format="yyyy-MM-dd"
						style="width: 690px;"
						v-model="openDay.openTime"
						align="right"
						type="date"
						placeholder="请选择日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="类型" prop="type" >
					<el-select v-model="openDay.type" placeholder="请选择开放日类型" style="width: 690px;">
						<el-option
							v-for="item in typeOptions"
							:key="item.value"
							:label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<!--<el-form-item label="备注" prop="remark" >-->
					<!--<el-input type="textarea" :rows="10" v-model="openDay.remark" size="medium" style="width: 690px;"></el-input>-->
				<!--</el-form-item>-->
			</el-form>
			<div style="text-align: left;margin-top: 10px;margin-left: 20px;">
				<el-button type="primary" @click="submit()">确 定</el-button>
			</div>
		</div>
</template>

<script>
		import config from "../../../config/global.js";

		var addOpenDayUrl = config.host+'/backend/product/openday/add.json';
		var updateOpenDayUrl = config.host + '/backend/product/openday/update.json';

    export default {
        name: "update-open-day-panel",
				data:function () {
					return {
						typeOptions:[{name:"固定开放日",value:0},{name:"临时开放日",value:1}],
						loading:false,
						rules: {
							openTime: [
								{ required: true, message: '请输入开放日日期', trigger: 'blur' }
							],
							type: [
								{ required: true, message: '请选择开放日类型', trigger: 'blur' }
							]

						},
					}
				},
				props:{
					openDay:{},
					product:{}
				},
				methods:{
					submit(){
						//添加开放日
						if(this.openDay.id == null ){
							if(this.loading == false ){
								this.loading = true;
								var param = {};
								param.openTime = this.openDay.openTime;
								param.orgId = "";
								param.remark = this.openDay.remark;
								param.type = this.openDay.type;
								param.productId = this.product.id;
								this.$http.post(addOpenDayUrl,param).then(
									function(response){
										var defaultResult = this.responseDefaultHandle(response);
										if(defaultResult == false )
											return;
										var res = response.body;
										if(response.data.result == 1){
											this.$message({
												message: '添加成功',
												type: 'success'
											});
											this.$emit('addsuccess');
										}else{
											this.$alert(response.data.emsg, '添加失败', {
												confirmButtonText: '确定'
											});
										}
										this.loading=false;
									},function(){
										this.$message.error("添加开放日失败");
										this.loading=false;
									})
							}
						}
						//更新开放日
						else{
							if(this.loading == false ){
								this.loading = true;
								var param = {};
								param.id = this.openDay.id;
								param.openTime = this.openDay.openTime;
								param.orgId = "";
								param.remark = this.openDay.remark;
								param.type = this.openDay.type;
								param.productId = this.product.id;
								this.$http.post(updateOpenDayUrl,param).then(
									function(response){
										var defaultResult = this.responseDefaultHandle(response);
										if(defaultResult == false )
											return;
										var res = response.body;
										if(response.data.result == 1){
											this.$message({
												message: '更新成功',
												type: 'success'
											});
											this.$emit('updatesuccess');
										}else{
											this.$alert(response.data.emsg, '添加失败', {
												confirmButtonText: '确定'
											});
										}
										this.loading=false;
									},function(){
										this.$message.error("更新开放日失败");
										this.loading=false;
									})
							}
						}
					}
				}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/product/UpdateOpenDayPanel.vue